import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaCheckCircle, FaShoppingCart, FaFileInvoiceDollar, FaTicketAlt, FaChevronLeft, FaChevronRight, FaLanguage } from 'react-icons/fa';
import { getLatestVersion } from './utils/versionApi';
import { useCompany } from '../context/CompanyContext';

// Sidebar menu configuration
const menuItems = [
  { label: 'Home', icon: <FaHome />, path: '/home' },
  { label: 'Profile', icon: <FaUser />, path: '/profile' },
  { label: 'Authorized', icon: <FaCheckCircle />, path: '/authorized' },
  { label: 'Purchased', icon: <FaShoppingCart />, path: '/purchased' },
  { label: 'Accounting', icon: <FaFileInvoiceDollar />, path: '/accounting' },
  { label: 'Ticket', icon: <FaTicketAlt />, path: '/ticket' },
  // { label: 'Languages', icon: <FaLanguage />, path: '/languages' },
];

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [version, setVersion] = useState('0.1.1');
  const { otherCompanies, currentCompany, switchCompany } = useCompany();

  useEffect(() => {
    const fetchVersion = async () => {
      const latestVersion = await getLatestVersion();
      setVersion(latestVersion);
    };
    fetchVersion();
    console.log("otherCompanies", otherCompanies);
  }, [otherCompanies]);

  return (
    <aside className={`h-screen ${collapsed ? 'w-20' : 'w-64'} bg-[#101828] text-white flex flex-col shadow-lg transition-all duration-300`}>
      {/* Logo */}
      <div className={`flex items-center ${collapsed ? 'justify-center' : ''} h-20 border-b border-gray-800 px-6`}>
        <img 
          src="/atraq-logo.png" 
          alt="ATraq Logo" 
          className={`h-12 object-contain`} 
          style={{ width: 'auto', maxWidth: '100%' }}
        />
        {!collapsed && <span className="ml-3 text-2xl font-bold tracking-wide">ATraq</span>}
      </div>
      
      {/* Prominent Switch Company (if more than one company) */}
      {otherCompanies && otherCompanies.length > 0 && (
        <div className="px-4 pt-4">
          <div className="bg-gradient-to-r from-[#A1E744] to-[#79BB2F] rounded-xl p-3 shadow-lg border border-[#c3ff6d]">
            <div className="flex items-center justify-between mb-2">
              {!collapsed && (
                <div>
                  <div className="text-xs font-bold text-[#0a1744] tracking-wide uppercase">
                    Switch Company
                  </div>
                  <div className="text-[11px] text-[#0a1744]/80 font-medium truncate max-w-[180px]">
                    {currentCompany?.CompanyName || currentCompany?.CommercialName || 'Current company'}
                  </div>
                </div>
              )}
              <div className={`flex items-center justify-center ${collapsed ? 'mx-auto' : ''}`}>
                <div className="w-8 h-8 rounded-full bg-white/90 flex items-center justify-center text-[#0a1744] font-bold text-xs shadow">
                  ⇄
                </div>
              </div>
            </div>
            <select
              className={`w-full bg-white text-xs text-[#0a1744] border border-[#0a1744]/20 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#0a1744] font-medium ${
                collapsed ? 'text-[0px] h-8 w-8 mx-auto p-0 border-none bg-transparent' : ''
              }`}
              defaultValue=""
              onChange={(e) => {
                const companyId = e.target.value;
                if (companyId) {
                  switchCompany(companyId);
                  e.target.value = '';
                }
              }}
              title="Switch Company"
            >
              <option value="" disabled>
                {collapsed ? '⋯' : 'Choose company'}
              </option>
              {otherCompanies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.CompanyName || company.CommercialName || company.id}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {/* Menu */}
      <nav className="flex-1 overflow-y-auto mt-2">
        <ul className="space-y-2 p-4">
          {menuItems.map((item) => (
            <li key={item.label}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center ${collapsed ? 'justify-center' : ''} px-4 py-3 text-base font-medium transition-colors duration-200 hover:bg-[#232d47] rounded-lg border-l-4 ${isActive ? 'bg-[#232d47] border-[#A1E744] text-white' : 'border-transparent text-white'}`
                }
              >
                <span className="text-lg">{item.icon}</span>
                {!collapsed && <span className="ml-4">{item.label}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Collapse Button and Version at the bottom */}
      <div className="mt-auto flex flex-col items-center p-6 border-t border-gray-800">
        <button
          className="p-2 rounded hover:bg-[#232d47] focus:outline-none mb-3"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        {!collapsed && <div className="text-xs text-gray-400">Version {version}</div>}
      </div>
    </aside>
  );
};

export default Sidebar; 